module.exports = __webpack_public_path__ + "media/images/rewards/bg-img-cbcf137a8d45c040b7a98ab87c94c93b.png";